import { createFileRoute } from "@tanstack/react-router";
import { KeywordServiceLanding } from "@/components/KeywordServiceLanding";
import { KEYWORD_SERVICE_PAGES, keywordServiceHead } from "@/lib/keywordServicePages";

export const Route = createFileRoute("/social-media-marketing-small-business-colorado")({
  head: () => keywordServiceHead(KEYWORD_SERVICE_PAGES.smallBusinessSocial),
  component: () => <KeywordServiceLanding page={KEYWORD_SERVICE_PAGES.smallBusinessSocial} />,
});
